module.exports = __webpack_public_path__ + "img/公众号.4ddd5ba0.jpg";